﻿export const mockedData = {
  placesOptions: [
    { Text: 'First place', Id: '8bca584c-3125-49eb-9727-a99de7302281' },
    { Text: 'Second place', Id: 'a942b646-0fbe-4180-aea4-fdc196b3e321' },
    { Text: 'Third and final long named place', Id: 'a942b646-0fbe-4180-aea4-fdc196b3e322' },
  ],
  permitTypeOptions: [
    { Text: 'One permit', Id: '8bca584c-3125-49eb-9727-a99de7302281' },
    { Text: 'Other permit', Id: 'a942b646-0fbe-4180-aea4-fdc196b3e321' },
    { Text: 'Yet another permit', Id: 'a942b646-0fbe-4180-aea4-fdc196b3e322' },
  ],
  permitUserOptions: [
    { Text: 'Demo Demosson', Id: '8bca584c-3125-49eb-9727-a99de7302281', FirstName: 'Demo', LastName: 'Demosson', Email: 'email1@email.se', Phone: '0123456789-1', LicensePlate: 'ABC123' },
    { Text: 'Test Testarsson', Id: 'a942b646-0fbe-4180-aea4-fdc196b3e321', FirstName: 'Test', LastName: 'Testsson', Email: 'email2@email.se', Phone: '0123456789-2', LicensePlate: 'ABC123' },
    { Text: 'Clicker Clickmeister', Id: 'a942b646-0fbe-4180-aea4-fdc196b3e322', FirstName: 'Clicker', LastName: 'Clickmeister', Email: 'email3@email.se', Phone: '0123456789-3', LicensePlate: 'ABC123' },
  ],
  permitDetails: [{
    customerId: '8bca584c-3125-49eb-9727-a99de7302281',
    salesLocation: 'a942b646-0fbe-4180-aea4-fdc196b3e321',
    permitType: 'a942b646-0fbe-4180-aea4-fdc196b3e322',
    startDate: new Date(),
    startTime: '09:00',
    endDate: new Date(),
    endTime: '16:00',
    spaceNumber: 'A1',
    notes: 'Lorem ipsum...',
  }, {
    firstName: 'Demo 2',
    lastName: 'Demosson 2',
    email: 'demo@demosson.se',
    phone: '+46 70 123 45 67',
    licensePlate: 'ABC 123',
    salesLocation: 'a942b646-0fbe-4180-aea4-fdc196b3e322',
    permitType: 'a942b646-0fbe-4180-aea4-fdc196b3e321',
    startDate: '2021-04-01',
    startTime: '10:00',
    endDate: '2021-04-07',
    endTime: '17:00',
    spaceNumber: 'B-2',
    notes: 'Lorem ipsum!',
  }],
    unlockedConfigs: [
        {
            uid: "740513cc-0527-4531-9309-a96b5c585f51",
            name: "ROXANA TEST2 Unlock Code",
            countryCode: "SE",
            generateUniqueCodes: false,
            numberOfCodes: 20,
            codePrefix: null,
            numberOfUsedCodes: 0,
            code: "ROXA",
            unlockingCodes: [
                {
                "code": "LTP-ROXA-HJ3N22JMJW",
                "comment": "for employee Maria Didriksson",
                "used": false,
                "sentOut": "2025-11-14T08:06:01.895Z",
                "sentOutBy": null,
                "usedBy": null
                },
            ],
            pmcIdRefs: [
                "22ae8f61-9b59-4857-814b-7b7590fe7b6e",
                "14453",
                "b327408b-66f1-4e01-8cc6-762417489ad3"
            ],
            serviceChannelRefs: [
                "Online Sales", 
                "AIMO_ONE"
            ]
        }
    ]
}
